<template>
  <label class="native-switch">
    <input
      type="checkbox"
      :checked="Boolean(modelValue)"
      @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    />
    <span>{{ modelValue ? activeText : inactiveText }}</span>
  </label>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue?: boolean;
    activeText?: string;
    inactiveText?: string;
  }>(),
  { modelValue: false, activeText: "是", inactiveText: "否" },
);

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void;
}>();
</script>

<style scoped>
.native-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
</style>
